import { type UseQueryResult, useQuery } from 'react-query';
import {
  RolePublishService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PublishedRolesVm,
} from '../../services/wealthlane-customer-services';
import { RolePublishFilterParamsType, type TableParamsType } from '../../types/common';

const useGetRolePublishList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // tableFilterInfo: RolePublishFilterParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PublishedRolesVm | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, companyName, roleName, _force } = tableInfo;
  // const { companyName, roleName } = tableFilterInfo;

  const rolePublishList = useQuery(
    [
      'getRolePublishList',
      companyName,
      roleName,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        RolePublishService.getApiCustomerApiCustomerCustomerSuccessRolesPublished(
          companyName,
          roleName,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return rolePublishList;
};

export default useGetRolePublishList;
